if (!customElements.get('russiangold-checkout-consent')) {
  customElements.define('russiangold-checkout-consent', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.input = this.querySelector('[data-russiangold-consent]');
      this.sync();

      this.addEventListener('change', () => this.sync());

      this.addEventListener('click', (event) => {
        if (!event.target.closest('[name="checkout"]') || this.input.checked) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        this.input.reportValidity();
      }, true);
    }

    sync() {
      this.querySelectorAll('[data-russiangold-express]').forEach((element) => {
        element.hidden = !this.input.checked;
        element.inert = !this.input.checked;
      });
    }
  });

  window.addEventListener('pageshow', () => {
    document
      .querySelectorAll('russiangold-checkout-consent')
      .forEach((element) => element.sync());
  });
}